export default __webpack_public_path__ + "static/media/f1.456ffbbf.jpeg";